var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","color":"#ef6b01","rounded":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }